<template>
  <!-- 页脚 -->
  <footer class="bg-gradient-to-r from-primary to-secondary text-white">
    <div class="max-w-7xl mx-auto px-6 lg:px-12 py-12">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
        <!-- 公司信息 -->
        <div class="lg:col-span-1">
          <div class="font-['Pacifico'] text-2xl font-bold mb-4">
            <img
              src="https://www.huizhaowo.com/assets/img/logo-w.png"
              alt="logo"
              width="100px"
              height="auto"
            />
          </div>
          <p class="text-blue-100 text-sm mb-4">
            专业会展设备租赁服务商，为您的活动提供一站式解决方案。
          </p>
          <div class="flex space-x-4">
            <div class="w-8 h-8 flex items-center justify-center">
              <i class="ri-wechat-fill text-lg"></i>
            </div>
            <div class="w-8 h-8 flex items-center justify-center">
              <i class="ri-weibo-fill text-lg"></i>
            </div>
            <div class="w-8 h-8 flex items-center justify-center">
              <i class="ri-tiktok-fill text-lg"></i>
            </div>
          </div>
        </div>
        <!-- 我的服务 -->
        <div>
          <h4 class="font-semibold mb-4">我的服务</h4>
          <ul class="space-y-2 text-sm text-blue-100">
            <li>
              <router-link to="/rent" class="hover:text-white transition-colors"
                >设备租赁</router-link
              >
            </li>
            <li>
              <router-link
                to="/caseshare"
                class="hover:text-white transition-colors"
                >展台搭建</router-link
              >
            </li>
            <li>
              <router-link
                to="/about"
                class="hover:text-white transition-colors"
                >会议服务</router-link
              >
            </li>
            <li>
              <router-link
                to="/about"
                class="hover:text-white transition-colors"
                >活动策划</router-link
              >
            </li>
          </ul>
        </div>
        <!-- 产品分类 -->
        <div>
          <h4 class="font-semibold mb-4">设备分类</h4>
          <ul class="space-y-2 text-sm text-blue-100">
            <li
              class="hover:text-white transition-colors hover:cursor-pointer"
              @click="toCategory(1)"
            >
              视听设备
            </li>
            <li
              class="hover:text-white transition-colors hover:cursor-pointer"
              @click="toCategory(2)"
            >
              会展家具
            </li>
            <li
              class="hover:text-white transition-colors hover:cursor-pointer"
              @click="toCategory(3)"
            >
              搭建材料
            </li>
            <li
              class="hover:text-white transition-colors hover:cursor-pointer"
              @click="toCategory(4)"
            >
              展示道具
            </li>
          </ul>
        </div>
        <!-- 资源链接 -->
        <div>
          <h4 class="font-semibold mb-4">资源链接</h4>
          <ul class="space-y-2 text-sm text-blue-100">
            <li>
              <router-link
                to="/quickorder"
                class="hover:text-white transition-colors"
                >快速预订</router-link
              >
            </li>
            <li>
              <router-link to="/join" class="hover:text-white transition-colors"
                >供应商加盟</router-link
              >
            </li>
            <li>
              <router-link
                to="/about"
                class="hover:text-white transition-colors"
                >联系我们</router-link
              >
            </li>
            <li>
              <router-link
                to="/help"
                class="hover:text-white transition-colors"
                >帮助中心</router-link
              >
            </li>
          </ul>
        </div>
        <!-- 联系信息 -->
        <div>
          <h4 class="font-semibold mb-4">联系我们</h4>
          <div class="space-y-3 text-sm text-blue-100">
            <div class="flex items-center">
              <div class="w-4 h-4 flex items-center justify-center mr-2">
                <i class="ri-phone-line"></i>
              </div>
              <span>010-84855667</span>
            </div>
            <div class="flex items-center">
              <div class="w-4 h-4 flex items-center justify-center mr-2">
                <i class="ri-mail-line"></i>
              </div>
              <span>service@redfocus.cn</span>
            </div>
            <div class="flex items-start">
              <div class="w-4 h-4 flex items-center justify-center mr-2 mt-0.5">
                <i class="ri-map-pin-line"></i>
              </div>
              <span>北京市西城区北三环中路29号华龙大厦B座24层</span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="border-t border-blue-400 mt-8 pt-8 text-center text-sm text-blue-100"
      >
        <p>
          &copy; 2025 红色光标 |
          <router-link to="/privacy" class="hover:text-white transition-colors"
            >隐私政策</router-link
          >
          |
          <router-link to="/terms" class="hover:text-white transition-colors"
            >服务条款</router-link
          >
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    // 跳转到rent,post请求,并传递categoryIds参数
    toCategory(categoryId) {
      this.$router.push({
        name: "Rent",
        params: { categoryIds: categoryId },
      });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Footer.vue